import { createFileRoute } from "@tanstack/react-router";
import { optionParam, textParam } from "@/utils/searchParams";
import {
  REQUEST_PHASES,
  type RequestPhase,
} from "@/components/requests/requestPhase";

// The list's search box and status filter live in the URL, so opening a request
// and coming back lands on the list the requester was reading (NAV-45's rule,
// applied to their own list by NAV-64).
export type MyRequestsSearch = {
  q?: string;
  /**
   * Every phase, not just every status: the filter offers "Not started yet" and
   * "Under evaluation" — the two a proposal can be in — and a value
   * `validateSearch` rejects is dropped on the way back, so those two would be
   * the one pair that did not survive the round trip.
   */
  status?: RequestPhase;
};

export const Route = createFileRoute("/end-user/my-requests")({
  validateSearch: (search: Record<string, unknown>): MyRequestsSearch => ({
    q: textParam(search.q),
    status: optionParam(REQUEST_PHASES, search.status),
  }),
});
